import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import RemoveCircleSharpIcon from "@mui/icons-material/RemoveCircleSharp";
import { Checkbox, Grid, IconButton } from "@mui/material";
import MathEditor from "../../components/RichText/MathEditor";
import NunitoText from "../../components/general/NunitoText";
import ReusableTextField from "../../components/general/ReusableTextField";
import { getBase64 } from "../../functions/upload";
import { createDefaultAnswer } from "./taskDefaults";

const titleStyle = { display: "flex", justifyContent: "center" };
const sectionHeaderStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
const taskLabelContainerStyle = {
  display: "flex",
  flexDirection: "column",
  paddingInline: 30,
};
const answerContainerStyle = { marginTop: 10 };

const Title = (value) => (
  <NunitoText
    value={value}
    fontSize={26}
    fontWeight={700}
    marginTop={20}
    borderBottom="1px solid"
    width={200}
    paddingBottom={5}
  />
);

function AddRemoveButtons({ count, updateAnswers }) {
  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => updateAnswers(count, "answerKeyAddAnswers")}
      >
        <AddCircleSharpIcon />
      </IconButton>
      {count > 0 && (
        <IconButton
          color="inherit"
          onClick={() => updateAnswers(count, "answerKeyDeleteAnswers")}
        >
          <RemoveCircleSharpIcon />
        </IconButton>
      )}
    </>
  );
}

export default function Answer({ count, answer, task, setTask, isReadOnly }) {
  const { image_label, answer_type, answer_structure } = task;
  const { task_labels } = answer;
  const { content, image } = task_labels[0];

  const updateAnswers = (index, identifier, value) => {
    const newTask = structuredClone(task);
    switch (identifier) {
      case "answerKeyAddAnswers":
        newTask.task_answers.splice(index + 1, 0, createDefaultAnswer());
        break;
      case "correct":
        const isSelecting = !newTask.task_answers[index].correct;
        newTask.task_answers.forEach((taskAnswer, taskAnswerIndex) => {
          const isCurrent = taskAnswerIndex === index;
          taskAnswer.correct = isSelecting && isCurrent;
          taskAnswer.answer = taskAnswer.correct ? "1" : null;
        });
        break;
      case "answerKeyDeleteAnswers":
        newTask.task_answers.splice(index, 1);
        break;
      case "content":
      case "image":
        newTask.task_answers[index].task_labels[0][identifier] = value;
        break;
      default:
        newTask.task_answers[index][identifier] = value;
    }
    setTask(newTask);
  };

  const noopUpdate = () => {};
  const safeUpdate = isReadOnly ? noopUpdate : updateAnswers;

  const handleFileInputChange = (file) => {
    getBase64(file)
      .then((result) => updateAnswers(count, "image", result))
      .catch((err) => {
        alert(`Error at handleFileInputChange: ${JSON.stringify(err)}`);
      });
  };

  const openFile = () =>
    document.getElementById(`file-upload-${count}`).click();

  const isOpen = answer_structure === "open";
  const labelPlaceholder = image_label
    ? "Click to upload image"
    : `Enter ${isOpen ? "Task" : "Answer"} Label`;

  const LabelField = () => (
    <ReusableTextField
      type="default"
      disabled={isReadOnly}
      placeholder={labelPlaceholder}
      state={image_label ? image : content}
      setState={updateAnswers}
      count={count}
      target="content"
      onClick={image_label ? openFile : undefined}
      readOnly={image_label || isReadOnly}
      onBlur={!image_label}
    />
  );

  const HiddenInput = () => (
    <input
      id={`file-upload-${count}`}
      type="file"
      style={{ display: "none" }}
      onChange={(e) => handleFileInputChange(e.target.files[0])}
    />
  );

  if (answer_type === "mcq") {
    // MCQ Default / Group
    return (
      <>
        {count === 0 && (
          <Grid container style={sectionHeaderStyle}>
            <Grid item xs style={titleStyle}>
              {Title("Answers")}
            </Grid>
            <Grid item width={200}>
              {Title("Correct Answer")}
            </Grid>
            {!isReadOnly && <Grid item xs={1} />}
          </Grid>
        )}
        <Grid
          container
          style={answerContainerStyle}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs style={taskLabelContainerStyle}>
            <MathEditor
              value={content ?? ""}
              onChange={isReadOnly ? undefined : (html) => updateAnswers(count, "content", html)}
              readOnly={isReadOnly}
            />
          </Grid>
          <Grid
            item
            xs={1}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Checkbox
              checked={!!answer.correct}
              onChange={() => safeUpdate(count, "correct")}
              disabled={isReadOnly}
            />
          </Grid>
          {!isReadOnly && (
            <Grid item xs={1}>
              <AddRemoveButtons count={count} updateAnswers={updateAnswers} />
            </Grid>
          )}
        </Grid>
      </>
    );
  }

  // Input type

  // Input Default / Group
  return (
    <>
      {count === 0 && (
        <Grid container alignItems="center">
          <Grid item xs={12} style={titleStyle}>
            {Title("Answer Label")}
          </Grid>
        </Grid>
      )}
      <Grid container style={answerContainerStyle} alignItems="center">
        <Grid item xs={12} style={taskLabelContainerStyle}>
          <LabelField />
          <HiddenInput />
        </Grid>
      </Grid>
    </>
  );
}
